<template>  
  <div class="tool-bar">
    <v-toolbar
    color="secondary"
    dark
      app
      clipped-left
      fixed
      class="elevation-2 pf-toolbar"
      >
      <v-toolbar-title style="width: 300px" class="ml-0">
        <v-toolbar-side-icon @click.stop="showHideDrawer" v-if="userIsAdmin()"></v-toolbar-side-icon>
        <span class="logo-span"><img src="https://d1dwubzia1nkxt.cloudfront.net/property-first.png" class="logo"> </span>
      </v-toolbar-title>
      <div class="d-flex align-center" style="margin-left: auto">
        <v-btn icon>
          <v-icon>mdi-search</v-icon>
        </v-btn>
      </div>
      <v-toolbar-items>
         <v-menu
         v-if="userIsAuthenticated()"
        offset-y
    >
      <v-btn slot="activator" flat>
       <v-icon>person</v-icon>  {{ currentUser().firstName }}
      </v-btn>
      <v-list>
                <v-list-tile>
          <v-list-tile-title @click.stop="onLogout" class="cursor">Logout</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
import shared from '../../mixins/shared'

export default {
  mixin: [shared],
  props: ['drawer'],
  data () {
    return {
      search: null,
      localDrawer: this.drawer,
      query: null,
      user: this.$store.getters.user
    }
  },
  watch: {
    drawer (newVal, oldVal) {
      this.localDrawer = newVal
    }
  },
  methods: {
    hideSearch () {
      this.search = true
    },
    onLogout () {
      this.$fb.auth().signOut()
      this.$store.dispatch('logout')
      this.$router.push('/')
    },
    showHideDrawer () {
      this.localDrawer = !this.localDrawer
      this.$emit('drawerStatus', this.localDrawer)
    },
    searchQuery () {
      this.$router.push({name: 'search', params: { query: this.query }})
    }
  },
  mounted () {
  }
}
</script>
<style>
.logo {
  height: 45px;
  width: auto;
}
.logo-span {
  display: inline-flex;
  -webkit-box-align: center;
-ms-flex-align: center;
align-items: center;
-webkit-box-pack: center;
-ms-flex-pack: center;
justify-content: center;
position: relative;
text-align: center;
vertical-align: middle;
}
.pf-toolbar {
  background-color: #514f4e;
}

.search-form {
  width: 100%
}
.search-box {
  min-width: 128px
}
.cursor {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// ToolBar.vue?2ec1ad0e